import { render, staticRenderFns } from "./TipoAtuacaoClassificacao.vue?vue&type=template&id=31d2d35d&scoped=true"
import script from "./TipoAtuacaoClassificacao.vue?vue&type=script&lang=js"
export * from "./TipoAtuacaoClassificacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d2d35d",
  null
  
)

export default component.exports